export default __webpack_public_path__ + "static/media/createImage.43c5a0c7.png";